module.exports = __webpack_public_path__ + "img/ENG-img-02.2e7c3675.jpg";